export const PROFILE_DEFAULTS = [
  '/images/profile-defoult/angry-birds.png',
  '/images/profile-defoult/assassins-creed.png',
  '/images/profile-defoult/atari.png',
  '/images/profile-defoult/barbarian.png',
  '/images/profile-defoult/gamepad.png',
  '/images/profile-defoult/gamer.png',
  '/images/profile-defoult/gears-of-war.png',
  '/images/profile-defoult/ghost.png',
  '/images/profile-defoult/joystick.png',
  '/images/profile-defoult/mushroom.png',
  '/images/profile-defoult/pikachu.png',
  '/images/profile-defoult/pokeball.png',
  '/images/profile-defoult/terrain.png',
] as const;

export const FALLBACK_PROFILE_IMAGE = PROFILE_DEFAULTS[0];